<template>
  <div class="praise" style="background: #fff">
    <!-- <nav-bar title="我的课程" /> -->
    <!-- <div class="praise_top">
      <div class="hd">
        <van-image
          fit="cover"
          height="60px"
          round
          :src="$getAvatar(userInfo.Avatar)"
          width="60px"
          @click="go('UserSetting')"
        />
        <h2>{{ userInfo.NickName }}</h2>
      </div>
    </div> -->
    <van-tabs
      v-model:active="active"
      animated
      color="#b57e48"
      sticky
      swipeable
      @change="onchangeTab"
    >
      <van-tab name="all" title="全部">
        <van-pull-refresh
          v-model="loading"
          success-text="刷新成功"
          @refresh="onRefresh"
        >
          <CourseList :list="allList" :show-free-class="showFreeClass" />
        </van-pull-refresh>
      </van-tab>
      <van-tab name="my" title="我的">
        <van-pull-refresh
          v-model="loading"
          success-text="刷新成功"
          @refresh="onRefresh"
        >
          <CourseList :list="myList" :show-free-class="showFreeClass" />
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
  <Tabbar />
  <FreeClass ref="freeClass" :random="Random" />
  <!-- <ExamineClass ref="examineClass" /> -->
</template>
<script>
  import CourseList from './components/CourseList'
  import FreeClass from './components/FreeClass.vue'
  // import ExamineClass from './components/ExamineClass.vue'
  import Tabbar from '@/components/Tabbar'
  import {
    reactive,
    ref,
    toRefs,
    watch,
    onMounted,
    nextTick,
    onActivated,
  } from 'vue'
  import store from '@/store'
  import api from '@/api'
  import { ImagePreview, Toast } from 'vant'
  import { useRouter, useRoute } from 'vue-router'
  import { wxShare } from '@/utils'
  export default {
    name: 'MyCourse',
    components: {
      CourseList,
      Tabbar,
      FreeClass,
      // ExamineClass,
    },
    props: {
      url: {
        type: String,
        default: 'case/PostSelectByTenant',
      },
      params: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    setup(props) {
      //是否打开页面立即加载数据 （当为搜索页时不立即加载）
      const allList = ref([])
      const myList = ref([])
      const userInfo = ref({})
      const tenant = ref(null)
      const loading = ref(false)
      const finished = ref(false)
      const refreshing = ref(false)
      const active = ref('all')
      const freeClass = ref(null)
      let surveyHost = ref(null)
      const { url, params, isSearch } = toRefs(props)
      const router = useRouter()
      const route = useRoute()
      const Random = ref(0)
      const form = {
        ActionType: 3,
        PageIndex: 1,
        PageSize: 6,
      }

      const goto = (name, option) => {
        router.push(Object.assign(option, { name }))
      }
      onActivated(() => {
        init()
      })
      const init = async () => {
        let url = await store.getters['system/getH5Url']
        url += 'home/#/pages/service/home/home'
        location.href = url
        // console.log('测试更新')
        // if (freeClass.value.showDialog) {
        //   freeClass.value.isAgreement()
        // }
        Random.value = Math.random()
        await getMyProductlist()
        const tenant = await store.getters['user/getTenant']
        tenant.value = tenant
        userInfo.value = store.getters['user/getUserInfo']
        surveyHost.value = await store.getters['system/getSurveyUrl']
        wxShare(tenant.TenantName, `欢迎来到【${tenant.TenantName}】学习中心`)
        // 如果页面上带了productId 则表示自动展开免费领取弹窗 20220816
        const query = route.query
        if (query.productId) {
          // let list = active.value === 'my' ? myList.value : allList.value
          // let product = null
          // list.forEach((item) => {
          //   if (item.ProductId === query.productId) {
          //     product = item
          //   }
          // })
          showFreeClass(query.productId)
        }
      }
      const getMyProductlist = async () => {
        tenant.value = await store.getters['user/getTenant']
        let url = 'service/GetAllSolutions'
        if (active.value === 'my') {
          url = 'service/GetMySolusions'
        }
        return store
          .dispatch(url, {
            tenantId: tenant.value.TenantId,
          })
          .then((data) => {
            const { Data, Code } = data
            loading.value = false

            if (active.value === 'my') {
              myList.value = Data
            } else {
              allList.value = Data
            }
          })
          .catch((e) => {})
      }

      const onchangeTab = () => {
        if (!allList.value.length || !myList.value.length) {
          getMyProductlist()
        }
      }

      const onRefresh = () => {
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        //loading.value = true
        getMyProductlist()
      }

      const showImg = (list, index) => {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          closeable: true,
        })
      }

      const go = (name) => {
        router.push({
          name,
        })
      }

      const onClickLeft = () => {
        router.back()
      }

      const showFreeClass = (item) => {
        freeClass.value.show(item)
      }

      return {
        active,
        allList,
        myList,
        loading,
        finished,
        refreshing,
        api,
        init,
        surveyHost,
        userInfo,
        tenant,
        onRefresh,
        onClickLeft,
        showImg,
        goto,
        go,
        onchangeTab,
        freeClass,
        showFreeClass,
        Random,
      }
    },
  }
</script>
<style lang="scss" scoped>
  button.van-button.van-button--primary.van-button--small {
    width: 100px;
  }
  .tit {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    margin: 25px 0;
    .line {
      width: 2px;
      height: 18px;
      background: #b57e48;
    }
    p {
      font-size: 18px;
      font-family: 'Source Han Sans CN';
      font-weight: 500;
      color: #000000;
      margin-left: 6px;
      font-weight: bold;
    }
  }
  .van-image {
    border: 3px solid #fff !important;
  }
  .praise_top {
    width: 100%;
    background-image: linear-gradient(to right, #151627, #3a3d64);
    .hd {
      height: 180px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0 0 0 30px;
      h2 {
        font-size: 18px;
        color: #fff;
        font-weight: normal;
        margin-left: 20px;
      }
    }
  }
</style>
